export default __webpack_public_path__ + "static/media/pincho-hombre-azul.97fd966b.png";